import { useEffect, useState } from "react";
import { qualityApi } from "./qualityApi";

// Modules, members, organizations and servers rarely change during a session,
// so they are fetched once and shared by every Quality screen and modal.
let cache = null;
let pending = null;

const EMPTY = {
    modules: [], members: [], orgs: [], servers: [], orgs_by_server: {}, server_versions: {},
    sprints: [], ticket_statuses: [],
};

// Hospitals on one server; falls back to every hospital when the server has
// none listed (e.g. the org directory has not been synced yet).
export const orgsFor = (meta, serverCode) => {
    const list = (meta.orgs_by_server || {})[serverCode];
    return list && list.length ? list : meta.orgs || [];
};

export default function useQualityMeta() {
    const [meta, setMeta] = useState(cache || EMPTY);

    useEffect(() => {
        if (cache) return undefined;
        let alive = true;
        pending = pending || qualityApi.getMeta().then((res) => {
            cache = { ...EMPTY, ...(res.data || {}) };
            return cache;
        }).catch(() => {
            pending = null;
            return EMPTY;
        });
        pending.then((m) => { if (alive) setMeta(m); });
        return () => { alive = false; };
    }, []);

    return meta;
}

export const subModulesOf = (meta, module) =>
    ((meta.modules || []).find((m) => m.name === module) || {}).sub_modules || [];
